import React from 'react'
import Icon from 'components/Icon/Icon'
import Text from 'particles/Text'
import { useNewTranslation } from 'hooks'
import styled from 'particles/themes/styled'

const EmptyWrapper = styled.div`
    width: 100%;
    flex-grow: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

const EmptyStepStateView: React.FC = () => {
    const [t] = useNewTranslation()
    return (
        <EmptyWrapper>
            <Icon.EmptyState2Icon />
            <Text scale="bodyL700" color="primary">
                {t('emptyState.noStepsAddedCustomTaskTitle')}
            </Text>
            <Text scale="bodyM400" color="secondary">
                {t('emptyState.noStepsAddedCustomTaskSubtitle')}
            </Text>
        </EmptyWrapper>
    )
}

export default EmptyStepStateView
